export const URL_SLUG = {
  PROFILE_UPDATE: '1_profile_update',
  VERIFY_PHONE: '2_verify_phone',
  WELCOME: '3_welcome',
  // inf_sp branch (4-6)
  LIVE_EVENTS: '4_live_events',
  CLUB_SUPPORT: '5_club_support',
  READY_INF_SP: '6_ready',
  // start_selfie branch (4-5)
  SELFIE: '4_selfie',
  READY_START_SELFIE: '5_ready',
  // start branch (4)
  READY_START: '4_ready',
  // account-setup
  ACCOUNT_PHONE: '1_phone_verification',
  ACCOUNT_PROFILE: '2_update_profile'
} as const

export type UrlSlug = typeof URL_SLUG[keyof typeof URL_SLUG]

export const URL_SLUG_PATTERN = /^\d+_[a-z_]+$/

export function isValidUrlSlug (value: string): boolean {
  return URL_SLUG_PATTERN.test(value)
}
